import * as yup from 'yup';

const validationSchema = yup.object().shape({
  packId: yup.string().label('Pack Id').required('Required'),
  smallerUnitId: yup.string().label('SmallerUnit Id'),
  gtin: yup.string().label('Barcode'),
  numberSmallerUnits: yup.number().integer().label('Number Units'),
  // .when('smallerUnitId', {
  //   is: (v) => v !== '',
  //   then: yup.number().required('Required'),
  // }),
  width: yup.number().label('Width'),
  length: yup.number().label('Length'),
  height: yup.number().label('Height'),
  netWeight: yup.number().label('Net Weight'),
  grossWeight: yup.number().label('Gross Weight'),
  maxLabelWidth: yup.number().label('Max Label Width'),
  maxLabelHeight: yup.number().label('Max Label Height'),
  weightCapacity: yup.number().label('Weight Capacity'),
});

export default validationSchema;
